<template>
  <v-card class="card pa-4 " color="gray10" flat>
    <div class="d-flex title">
      <v-icon>$editList</v-icon>
      <h2 class="font-Light-16 ms-2 ">
        {{ $t("corporateAccount.manage.create.step1.uploadDocuments") }}
      </h2>
    </div>
    <p class="gray3--text font-Regular-16 py-4">
      {{ $t("corporateAccount.manage.create.step2.uploadRequiredDocuments") }}
    </p>

    <div class="border-dashed document-input">
      <v-file-input
        @change="uploadTempFile"
        v-model="fileTemp"
        color="deep-purple accent-4"
        :placeholder="
          $t('corporateAccount.manage.create.step1.uploadDocuments')
        "
        :prepend-icon="false"
        :messages="
          $t('corporateAccount.manage.create.step2.allowedFileFormats', {
            formats: allowFormats
          })
        "
        prepend-inner-icon="mdi-paperclip"
        outlined
        :loading="isLoading"
      >
      </v-file-input>
    </div>

    <div
      v-for="file in files"
      :key="file.id"
      class="mt-4 primary1 pa-4 rounded-lg d-flex align-center justify-space-between"
    >
      <div class="d-flex align-center" style="gap: 4px">
        <v-img :src="file.url" width="33" height="33" />
        <span>{{ file.name }}</span>
      </div>
      <v-btn :loading="deleting_ID == file.id" text>
        <v-icon style="cursor: pointer;" @click="deleteTempFile(file.id)"
          >$trashDeleteBinGrey</v-icon
        >
      </v-btn>
    </div>

    <div class="d-flex items-center justify-center mt-16">
      <v-btn
        x-large
        color="primary"
        class="mx-auto px-16"
        :loading="isLoading"
        :disabled="files.length <= 0"
        @click="submitCorporateAccount"
      >
        {{ $t("corporateAccount.manage.create.step1.submitAndContinue") }}
      </v-btn>
    </div>
  </v-card>
</template>
<script lang="ts">
import legalService from "@/services/modules/legalService";
export default {
  data() {
    return {
      CA_ID: this.$route.query.CA_ID,
      isLoading: false,
      deleting_ID: null,
      files: [],
      fileTemp: null,
      allowFormats: [".jpg", ".jpeg", ".png"].join(", ")
    };
  },
  mounted() {
    this.fetchTempFiles();
  },
  methods: {
    submitCorporateAccount() {
      this.isLoading = true;
      legalService
        .submitCorporateAccount(this.CA_ID)
        .then(() => {
          this.$emit("nextStep", 3, this.CA_ID);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    fetchTempFiles() {
      legalService.getTempFiles(this.CA_ID).then(res => {
        this.files = res.data.data;
        console.log("Temp files", res.data);
      });
    },
    uploadTempFile(event) {
      const formData = new FormData();
      formData.append("file", event);
      this.isLoading = true;
      legalService
        .uploadTempFile(formData, this.CA_ID)
        .then(() => this.fetchTempFiles())
        .finally(() => {
          this.isLoading = false;
        });
    },
    deleteTempFile(id) {
      this.deleting_ID = id;
      legalService
        .deleteTempFile(this.CA_ID, { file_id: id })
        .then(() => this.fetchTempFiles());
    }
  }
};
</script>
<style lang="scss">
.document-input {
  .v-text-field .v-messages__message {
    color: var(--v-gray-8-base) !important;
  }
}
</style>
